<template>
  <div class="wrapper">
    <div class="header_wrapper">
      <v-toolbar color="primary" dark class="position-relative">
        <v-btn icon @click="routerBack" style="z-index: 2;">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>

        <v-toolbar-title 
          class="text-center position-absolute" 
          style="left: 0; right: 0; pointer-events: none; width: 100%; margin-left: 0;"
        >
          {{ t('settingNotification.title') }}
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn
          @click="putMe"
          :loading="btnLoading"
          text
          class="font-weight-bold"
          style="z-index: 2;"
        >
          {{ t('settingNotification.save') }}
        </v-btn>
      </v-toolbar>
    </div>

    <div class="content_wrapper pa-2">
      <div
        v-for="n in notifications"
        :key="n.key"
      >
        <div class="text-body-1 text-blue-grey-darken-5">
          {{ n.label }}
        </div>

        <v-select
          color="primary"
          base-color="primary"
          v-model="n.value"
          :items="options"
          item-title="text"
          item-value="value"
          variant="outlined"
          density="compact"
        ></v-select>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from 'vue';
import { when } from '@/service/Switch';
import { Toast } from '@/service/SweetAlert';

import { meModule } from '@/store/entityModules/me';
import { t } from '@/i18n';

const HIDDEN_NOTIFICATION_KEYS = ['invoiceSettled', 'creditSettled', 'creditFailed'] as const;

interface DataType {
  notifications: Array<{
    parentId: number;
    key: string;
    label: string;
    value: number;
  }>;
  btnLoading: boolean;
}

export default defineComponent({

  computed: {
    options() {
      return [
        { text: this.t('settingNotification.options.both'), value: 0 },
        { text: this.t('settingNotification.options.pushOnly'), value: 1 },
        { text: this.t('settingNotification.options.emailOnly'), value: 2 },
        { text: this.t('settingNotification.options.none'), value: 3 },
      ];
    },
    notificationsMap() {
      return {
        absentConfirmed: this.t('settingNotification.notifications.absentConfirmed'),
        pickupConfirmed: this.t('settingNotification.notifications.pickupConfirmed'),
        chatReceived: this.t('settingNotification.notifications.chatReceived'),
        growthUpdated: this.t('settingNotification.notifications.growthUpdated'),
        // invoiceSettled: this.t('settingNotification.notifications.invoiceSettled'),
        // creditSettled: this.t('settingNotification.notifications.creditSettled'),
        // creditFailed: this.t('settingNotification.notifications.creditFailed'),
      };
    },
    me() {
      return meModule.me;
    },
  },

  data: (): DataType =>({
    notifications: [],
    btnLoading: false,
  }),

  methods: {
    t,
    routerBack() {
      this.$router.replace('/setting/various');
    },
    async putMe() {
      if (this.me) {
        this.btnLoading = true;
        try {
          const parentId = this.me.parentId;
          const meNotifications = this.me.notifications as Record<string, number>;
          const hiddenPayload = HIDDEN_NOTIFICATION_KEYS.filter((key) => key in meNotifications).map(
            (key) => ({ parentId, key, value: meNotifications[key] }),
          );
          await meModule.putMe({
            firstName: this.me.firstName,
            lastName: this.me.lastName,
            firstNameKana: this.me.firstNameKana,
            lastNameKana: this.me.lastNameKana,
            imageUrl: this.me.imageUrl,
            birth: this.me.birth,
            bloodType: this.me.bloodType,
            tel: this.me.tel,
            notifications: [
              ...this.notifications.map(({ parentId: pid, key, value }) => ({ parentId: pid, key, value })),
              ...hiddenPayload,
            ],
            isNewinfo: this.me.isNewinfo,
          });
          this.btnLoading = false;
          Toast.fire({
            icon: 'success',
            title: this.t('settingNotification.successMessage'),
          });
        } catch {
          this.btnLoading = false;
        }
      }
    },
  },

  mounted() {
    if (this.me) {
      const parentId = this.me.parentId;
      const hidden = new Set<string>(HIDDEN_NOTIFICATION_KEYS);
      const keys = Object.keys(this.me.notifications).filter((k) => !hidden.has(k));
      keys.map((k) => {
        let label = '';
        const map = this.notificationsMap;
        when(k)
          .on((v) => v === 'absentConfirmed', async () => {
            label = map.absentConfirmed;
          })
          .on((v) => v === 'pickupConfirmed', async () => {
            label = map.pickupConfirmed;
          })
          .on((v) => v === 'chatReceived', async () => {
            label = map.chatReceived;
          })
          .on((v) => v === 'growthUpdated', async () => {
            label = map.growthUpdated;
          });
          // .on((v) => v === 'invoiceSettled', async () => {
          //   label = map.invoiceSettled;
          // })
          // .on((v) => v === 'creditSettled', async () => {
          //   label = map.creditSettled;
          // })
          // .on((v) => v === 'creditFailed', async () => {
          //   label = map.creditFailed;
          // });
        if (this.me && label) {
          this.notifications.push({
            parentId,
            key: k,
            label,
            value: this.me.notifications[k],
          });
        }
      });
    }
  },

});
</script>
<style lang="scss" scoped>
.wrapper {
  padding-top: calc(var(--app-top-offset) + 56px); // ← ヘッダー分
  margin-bottom: calc(env(safe-area-inset-bottom) + 56px);
}

/* ===== ヘッダー ===== */
.header_wrapper {
  height: 56px;
  width: 100%;
  position: fixed;
  top: var(--app-top-offset); // ← 超重要
  left: 0;
  z-index: 100;

  .outline {
    border: 1px solid rgb(var(--v-theme-primary));
  }
}

/* ===== フォーム余白 ===== */
.v-form {
  margin-top: 8px;
}

/* ===== ラベルサイズ ===== */
.label-size > .v-input__control > .v-input__slot > .v-input--selection-controls__input > label {
  font-size: 12px;
}
// リストはヘッダー分だけ下げる
.v-list {
  margin-top: calc(env(safe-area-inset-top));
}
</style>
